/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
} from 'data-fetching-client';
import * as References from './ReviewsRpc';
import * as Queries from './ReviewsRpc.dfc.new';
import type { AdditionalContextArgs } from './ReviewsRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseGenerateTitleQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GenerateTitleResponseType>,
    References.GenerateTitleRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'generateTitle', References.GenerateTitleResponseType>
        : References.GenerateTitleResponseType)
    | undefined;
};

export function useGenerateTitleQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GenerateTitleResponseType>,
    References.GenerateTitleRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGenerateTitleQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GENERATE_TITLE_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            generateTitle: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGenerateTitleQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGenerateTitleQueryReturn<T>;
}

type UseGenerateTitleLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GenerateTitleResponseType>,
    References.GenerateTitleRequestType,
    T extends true
      ? Record<'generateTitle', References.GenerateTitleResponseType>
      : References.GenerateTitleResponseType
  >;

export function useGenerateTitleLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GenerateTitleResponseType>,
    References.GenerateTitleRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGenerateTitleLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GENERATE_TITLE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            generateTitle: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGenerateTitleLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGenerateTitleLazyQueryReturn<T>;
}

type UseGenerateTitleSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GenerateTitleResponseType>,
    References.GenerateTitleRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'generateTitle', References.GenerateTitleResponseType>
    : References.GenerateTitleResponseType;
};

export function useGenerateTitleSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GenerateTitleResponseType>,
    References.GenerateTitleRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGenerateTitleSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GENERATE_TITLE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            generateTitle: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGenerateTitleSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGenerateTitleSuspenseQueryReturn<T>;
}

type UseGetSummaryQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetSummaryResponseType>,
    References.GetSummaryRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getSummary', References.GetSummaryResponseType>
        : References.GetSummaryResponseType)
    | undefined;
};

export function useGetSummaryQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetSummaryResponseType>,
    References.GetSummaryRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSummaryQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_SUMMARY_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSummary: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return { data: legacyFormatData, ...rest } as UseGetSummaryQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetSummaryQueryReturn<T>;
}

type UseGetSummaryLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetSummaryResponseType>,
    References.GetSummaryRequestType,
    T extends true
      ? Record<'getSummary', References.GetSummaryResponseType>
      : References.GetSummaryResponseType
  >;

export function useGetSummaryLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetSummaryResponseType>,
    References.GetSummaryRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSummaryLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_SUMMARY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSummary: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetSummaryLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetSummaryLazyQueryReturn<T>;
}

type UseGetSummarySuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetSummaryResponseType>,
    References.GetSummaryRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getSummary', References.GetSummaryResponseType>
    : References.GetSummaryResponseType;
};

export function useGetSummarySuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetSummaryResponseType>,
    References.GetSummaryRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSummarySuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_SUMMARY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getSummary: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetSummarySuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetSummarySuspenseQueryReturn<T>;
}

type UseGetEditabilityQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetEditabilityResponseType>,
    References.GetEditabilityRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getEditability', References.GetEditabilityResponseType>
        : References.GetEditabilityResponseType)
    | undefined;
};

export function useGetEditabilityQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetEditabilityResponseType>,
    References.GetEditabilityRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetEditabilityQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_EDITABILITY_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getEditability: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetEditabilityQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetEditabilityQueryReturn<T>;
}

type UseGetEditabilityLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetEditabilityResponseType>,
    References.GetEditabilityRequestType,
    T extends true
      ? Record<'getEditability', References.GetEditabilityResponseType>
      : References.GetEditabilityResponseType
  >;

export function useGetEditabilityLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetEditabilityResponseType>,
    References.GetEditabilityRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetEditabilityLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_EDITABILITY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getEditability: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetEditabilityLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetEditabilityLazyQueryReturn<T>;
}

type UseGetEditabilitySuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetEditabilityResponseType>,
    References.GetEditabilityRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getEditability', References.GetEditabilityResponseType>
    : References.GetEditabilityResponseType;
};

export function useGetEditabilitySuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetEditabilityResponseType>,
    References.GetEditabilityRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetEditabilitySuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_EDITABILITY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getEditability: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetEditabilitySuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetEditabilitySuspenseQueryReturn<T>;
}

type UseGetThemesQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetThemesResponseType>,
    References.GetThemesRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getThemes', References.GetThemesResponseType>
        : References.GetThemesResponseType)
    | undefined;
};

export function useGetThemesQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetThemesResponseType>,
    References.GetThemesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetThemesQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_THEMES_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getThemes: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return { data: legacyFormatData, ...rest } as UseGetThemesQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetThemesQueryReturn<T>;
}

type UseGetThemesLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetThemesResponseType>,
    References.GetThemesRequestType,
    T extends true
      ? Record<'getThemes', References.GetThemesResponseType>
      : References.GetThemesResponseType
  >;

export function useGetThemesLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetThemesResponseType>,
    References.GetThemesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetThemesLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_THEMES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getThemes: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetThemesLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetThemesLazyQueryReturn<T>;
}

type UseGetThemesSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetThemesResponseType>,
    References.GetThemesRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getThemes', References.GetThemesResponseType>
    : References.GetThemesResponseType;
};

export function useGetThemesSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetThemesResponseType>,
    References.GetThemesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetThemesSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(Queries.GET_THEMES_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getThemes: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetThemesSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetThemesSuspenseQueryReturn<T>;
}

type UseSearchReviewsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.SearchReviewsResponseType>,
    References.SearchReviewsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'searchReviews', References.SearchReviewsResponseType>
        : References.SearchReviewsResponseType)
    | undefined;
};

export function useSearchReviewsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.SearchReviewsResponseType>,
    References.SearchReviewsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSearchReviewsQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.SEARCH_REVIEWS_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            searchReviews: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseSearchReviewsQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseSearchReviewsQueryReturn<T>;
}

type UseSearchReviewsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.SearchReviewsResponseType>,
    References.SearchReviewsRequestType,
    T extends true
      ? Record<'searchReviews', References.SearchReviewsResponseType>
      : References.SearchReviewsResponseType
  >;

export function useSearchReviewsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.SearchReviewsResponseType>,
    References.SearchReviewsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSearchReviewsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.SEARCH_REVIEWS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            searchReviews: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseSearchReviewsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseSearchReviewsLazyQueryReturn<T>;
}

type UseSearchReviewsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.SearchReviewsResponseType>,
    References.SearchReviewsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'searchReviews', References.SearchReviewsResponseType>
    : References.SearchReviewsResponseType;
};

export function useSearchReviewsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.SearchReviewsResponseType>,
    References.SearchReviewsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSearchReviewsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.SEARCH_REVIEWS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            searchReviews: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseSearchReviewsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseSearchReviewsSuspenseQueryReturn<T>;
}

type UseSearchReviewsLegacyQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.SearchReviewsLegacyResponseType>,
    References.SearchReviewsLegacyRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'searchReviewsLegacy',
            References.SearchReviewsLegacyResponseType
          >
        : References.SearchReviewsLegacyResponseType)
    | undefined;
};

export function useSearchReviewsLegacyQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.SearchReviewsLegacyResponseType>,
    References.SearchReviewsLegacyRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSearchReviewsLegacyQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.SEARCH_REVIEWS_LEGACY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            searchReviewsLegacy: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseSearchReviewsLegacyQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseSearchReviewsLegacyQueryReturn<T>;
}

type UseSearchReviewsLegacyLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.SearchReviewsLegacyResponseType>,
    References.SearchReviewsLegacyRequestType,
    T extends true
      ? Record<
          'searchReviewsLegacy',
          References.SearchReviewsLegacyResponseType
        >
      : References.SearchReviewsLegacyResponseType
  >;

export function useSearchReviewsLegacyLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.SearchReviewsLegacyResponseType>,
    References.SearchReviewsLegacyRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSearchReviewsLegacyLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.SEARCH_REVIEWS_LEGACY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            searchReviewsLegacy: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseSearchReviewsLegacyLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseSearchReviewsLegacyLazyQueryReturn<T>;
}

type UseSearchReviewsLegacySuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.SearchReviewsLegacyResponseType>,
    References.SearchReviewsLegacyRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'searchReviewsLegacy', References.SearchReviewsLegacyResponseType>
    : References.SearchReviewsLegacyResponseType;
};

export function useSearchReviewsLegacySuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.SearchReviewsLegacyResponseType>,
    References.SearchReviewsLegacyRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSearchReviewsLegacySuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.SEARCH_REVIEWS_LEGACY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            searchReviewsLegacy: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseSearchReviewsLegacySuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseSearchReviewsLegacySuspenseQueryReturn<T>;
}

type UseCheckReviewabilityQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.CheckReviewabilityResponseType>,
    References.CheckReviewabilityRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'checkReviewability',
            References.CheckReviewabilityResponseType
          >
        : References.CheckReviewabilityResponseType)
    | undefined;
};

export function useCheckReviewabilityQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.CheckReviewabilityResponseType>,
    References.CheckReviewabilityRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCheckReviewabilityQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.CHECK_REVIEWABILITY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            checkReviewability: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseCheckReviewabilityQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseCheckReviewabilityQueryReturn<T>;
}

type UseCheckReviewabilityLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.CheckReviewabilityResponseType>,
    References.CheckReviewabilityRequestType,
    T extends true
      ? Record<'checkReviewability', References.CheckReviewabilityResponseType>
      : References.CheckReviewabilityResponseType
  >;

export function useCheckReviewabilityLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.CheckReviewabilityResponseType>,
    References.CheckReviewabilityRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCheckReviewabilityLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.CHECK_REVIEWABILITY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            checkReviewability: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseCheckReviewabilityLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseCheckReviewabilityLazyQueryReturn<T>;
}

type UseCheckReviewabilitySuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.CheckReviewabilityResponseType>,
    References.CheckReviewabilityRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'checkReviewability', References.CheckReviewabilityResponseType>
    : References.CheckReviewabilityResponseType;
};

export function useCheckReviewabilitySuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.CheckReviewabilityResponseType>,
    References.CheckReviewabilityRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCheckReviewabilitySuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.CHECK_REVIEWABILITY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            checkReviewability: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseCheckReviewabilitySuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseCheckReviewabilitySuspenseQueryReturn<T>;
}

type UseCheckReviewabilityByAppIdsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.CheckReviewabilityByAppIdsResponseType>,
    References.CheckReviewabilityByAppIdsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'checkReviewabilityByAppIds',
            References.CheckReviewabilityByAppIdsResponseType
          >
        : References.CheckReviewabilityByAppIdsResponseType)
    | undefined;
};

export function useCheckReviewabilityByAppIdsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.CheckReviewabilityByAppIdsResponseType>,
    References.CheckReviewabilityByAppIdsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCheckReviewabilityByAppIdsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.CHECK_REVIEWABILITY_BY_APP_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            checkReviewabilityByAppIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseCheckReviewabilityByAppIdsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseCheckReviewabilityByAppIdsQueryReturn<T>;
}

type UseCheckReviewabilityByAppIdsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.CheckReviewabilityByAppIdsResponseType>,
    References.CheckReviewabilityByAppIdsRequestType,
    T extends true
      ? Record<
          'checkReviewabilityByAppIds',
          References.CheckReviewabilityByAppIdsResponseType
        >
      : References.CheckReviewabilityByAppIdsResponseType
  >;

export function useCheckReviewabilityByAppIdsLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.CheckReviewabilityByAppIdsResponseType>,
    References.CheckReviewabilityByAppIdsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCheckReviewabilityByAppIdsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.CHECK_REVIEWABILITY_BY_APP_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            checkReviewabilityByAppIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseCheckReviewabilityByAppIdsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseCheckReviewabilityByAppIdsLazyQueryReturn<T>;
}

type UseCheckReviewabilityByAppIdsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.CheckReviewabilityByAppIdsResponseType>,
    References.CheckReviewabilityByAppIdsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'checkReviewabilityByAppIds',
        References.CheckReviewabilityByAppIdsResponseType
      >
    : References.CheckReviewabilityByAppIdsResponseType;
};

export function useCheckReviewabilityByAppIdsSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.CheckReviewabilityByAppIdsResponseType>,
    References.CheckReviewabilityByAppIdsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCheckReviewabilityByAppIdsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.CHECK_REVIEWABILITY_BY_APP_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            checkReviewabilityByAppIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseCheckReviewabilityByAppIdsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseCheckReviewabilityByAppIdsSuspenseQueryReturn<T>;
}

type UseGetOverallStatsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetOverallStatsResponseType>,
    References.GetOverallStatsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getOverallStats', References.GetOverallStatsResponseType>
        : References.GetOverallStatsResponseType)
    | undefined;
};

export function useGetOverallStatsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetOverallStatsResponseType>,
    References.GetOverallStatsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetOverallStatsQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_OVERALL_STATS_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getOverallStats: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetOverallStatsQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetOverallStatsQueryReturn<T>;
}

type UseGetOverallStatsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetOverallStatsResponseType>,
    References.GetOverallStatsRequestType,
    T extends true
      ? Record<'getOverallStats', References.GetOverallStatsResponseType>
      : References.GetOverallStatsResponseType
  >;

export function useGetOverallStatsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetOverallStatsResponseType>,
    References.GetOverallStatsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetOverallStatsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_OVERALL_STATS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getOverallStats: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetOverallStatsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetOverallStatsLazyQueryReturn<T>;
}

type UseGetOverallStatsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetOverallStatsResponseType>,
    References.GetOverallStatsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getOverallStats', References.GetOverallStatsResponseType>
    : References.GetOverallStatsResponseType;
};

export function useGetOverallStatsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetOverallStatsResponseType>,
    References.GetOverallStatsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetOverallStatsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_OVERALL_STATS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getOverallStats: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetOverallStatsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetOverallStatsSuspenseQueryReturn<T>;
}

type UseGetOverallStatsBatchQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetOverallStatsBatchResponseType>,
    References.GetOverallStatsBatchRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getOverallStatsBatch',
            References.GetOverallStatsBatchResponseType
          >
        : References.GetOverallStatsBatchResponseType)
    | undefined;
};

export function useGetOverallStatsBatchQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetOverallStatsBatchResponseType>,
    References.GetOverallStatsBatchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetOverallStatsBatchQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_OVERALL_STATS_BATCH_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getOverallStatsBatch: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetOverallStatsBatchQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetOverallStatsBatchQueryReturn<T>;
}

type UseGetOverallStatsBatchLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetOverallStatsBatchResponseType>,
    References.GetOverallStatsBatchRequestType,
    T extends true
      ? Record<
          'getOverallStatsBatch',
          References.GetOverallStatsBatchResponseType
        >
      : References.GetOverallStatsBatchResponseType
  >;

export function useGetOverallStatsBatchLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetOverallStatsBatchResponseType>,
    References.GetOverallStatsBatchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetOverallStatsBatchLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_OVERALL_STATS_BATCH_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getOverallStatsBatch: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetOverallStatsBatchLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetOverallStatsBatchLazyQueryReturn<T>;
}

type UseGetOverallStatsBatchSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetOverallStatsBatchResponseType>,
    References.GetOverallStatsBatchRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getOverallStatsBatch',
        References.GetOverallStatsBatchResponseType
      >
    : References.GetOverallStatsBatchResponseType;
};

export function useGetOverallStatsBatchSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetOverallStatsBatchResponseType>,
    References.GetOverallStatsBatchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetOverallStatsBatchSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_OVERALL_STATS_BATCH_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getOverallStatsBatch: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetOverallStatsBatchSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetOverallStatsBatchSuspenseQueryReturn<T>;
}

type UseGetReviewStatsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetReviewStatsResponseType>,
    References.GetReviewStatsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getReviewStats', References.GetReviewStatsResponseType>
        : References.GetReviewStatsResponseType)
    | undefined;
};

export function useGetReviewStatsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetReviewStatsResponseType>,
    References.GetReviewStatsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetReviewStatsQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_REVIEW_STATS_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getReviewStats: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetReviewStatsQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetReviewStatsQueryReturn<T>;
}

type UseGetReviewStatsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetReviewStatsResponseType>,
    References.GetReviewStatsRequestType,
    T extends true
      ? Record<'getReviewStats', References.GetReviewStatsResponseType>
      : References.GetReviewStatsResponseType
  >;

export function useGetReviewStatsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetReviewStatsResponseType>,
    References.GetReviewStatsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetReviewStatsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_REVIEW_STATS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getReviewStats: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetReviewStatsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetReviewStatsLazyQueryReturn<T>;
}

type UseGetReviewStatsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetReviewStatsResponseType>,
    References.GetReviewStatsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getReviewStats', References.GetReviewStatsResponseType>
    : References.GetReviewStatsResponseType;
};

export function useGetReviewStatsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetReviewStatsResponseType>,
    References.GetReviewStatsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetReviewStatsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_REVIEW_STATS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getReviewStats: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetReviewStatsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetReviewStatsSuspenseQueryReturn<T>;
}

type UseGetReviewStatsBatchQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetReviewStatsBatchResponseType>,
    References.GetReviewStatsBatchRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getReviewStatsBatch',
            References.GetReviewStatsBatchResponseType
          >
        : References.GetReviewStatsBatchResponseType)
    | undefined;
};

export function useGetReviewStatsBatchQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetReviewStatsBatchResponseType>,
    References.GetReviewStatsBatchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetReviewStatsBatchQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_REVIEW_STATS_BATCH_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getReviewStatsBatch: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetReviewStatsBatchQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetReviewStatsBatchQueryReturn<T>;
}

type UseGetReviewStatsBatchLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetReviewStatsBatchResponseType>,
    References.GetReviewStatsBatchRequestType,
    T extends true
      ? Record<
          'getReviewStatsBatch',
          References.GetReviewStatsBatchResponseType
        >
      : References.GetReviewStatsBatchResponseType
  >;

export function useGetReviewStatsBatchLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetReviewStatsBatchResponseType>,
    References.GetReviewStatsBatchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetReviewStatsBatchLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_REVIEW_STATS_BATCH_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getReviewStatsBatch: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetReviewStatsBatchLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetReviewStatsBatchLazyQueryReturn<T>;
}

type UseGetReviewStatsBatchSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetReviewStatsBatchResponseType>,
    References.GetReviewStatsBatchRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getReviewStatsBatch', References.GetReviewStatsBatchResponseType>
    : References.GetReviewStatsBatchResponseType;
};

export function useGetReviewStatsBatchSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetReviewStatsBatchResponseType>,
    References.GetReviewStatsBatchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetReviewStatsBatchSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_REVIEW_STATS_BATCH_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getReviewStatsBatch: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetReviewStatsBatchSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetReviewStatsBatchSuspenseQueryReturn<T>;
}

type UseGetPrivateFeedbackQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetPrivateFeedbackResponseType>,
    References.GetPrivateFeedbackRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getPrivateFeedback',
            References.GetPrivateFeedbackResponseType
          >
        : References.GetPrivateFeedbackResponseType)
    | undefined;
};

export function useGetPrivateFeedbackQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetPrivateFeedbackResponseType>,
    References.GetPrivateFeedbackRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetPrivateFeedbackQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_PRIVATE_FEEDBACK_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getPrivateFeedback: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetPrivateFeedbackQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetPrivateFeedbackQueryReturn<T>;
}

type UseGetPrivateFeedbackLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetPrivateFeedbackResponseType>,
    References.GetPrivateFeedbackRequestType,
    T extends true
      ? Record<'getPrivateFeedback', References.GetPrivateFeedbackResponseType>
      : References.GetPrivateFeedbackResponseType
  >;

export function useGetPrivateFeedbackLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetPrivateFeedbackResponseType>,
    References.GetPrivateFeedbackRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetPrivateFeedbackLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_PRIVATE_FEEDBACK_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getPrivateFeedback: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetPrivateFeedbackLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetPrivateFeedbackLazyQueryReturn<T>;
}

type UseGetPrivateFeedbackSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetPrivateFeedbackResponseType>,
    References.GetPrivateFeedbackRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getPrivateFeedback', References.GetPrivateFeedbackResponseType>
    : References.GetPrivateFeedbackResponseType;
};

export function useGetPrivateFeedbackSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetPrivateFeedbackResponseType>,
    References.GetPrivateFeedbackRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetPrivateFeedbackSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_PRIVATE_FEEDBACK_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getPrivateFeedback: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetPrivateFeedbackSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetPrivateFeedbackSuspenseQueryReturn<T>;
}

type UseGetReviewRequestEmailTokensQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetReviewRequestEmailTokensResponseType>
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getReviewRequestEmailTokens',
            References.GetReviewRequestEmailTokensResponseType
          >
        : References.GetReviewRequestEmailTokensResponseType)
    | undefined;
};

export function useGetReviewRequestEmailTokensQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetReviewRequestEmailTokensResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetReviewRequestEmailTokensQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_REVIEW_REQUEST_EMAIL_TOKENS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getReviewRequestEmailTokens: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetReviewRequestEmailTokensQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetReviewRequestEmailTokensQueryReturn<T>;
}

type UseGetReviewRequestEmailTokensLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetReviewRequestEmailTokensResponseType>,
    {},
    T extends true
      ? Record<
          'getReviewRequestEmailTokens',
          References.GetReviewRequestEmailTokensResponseType
        >
      : References.GetReviewRequestEmailTokensResponseType
  >;

export function useGetReviewRequestEmailTokensLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetReviewRequestEmailTokensResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetReviewRequestEmailTokensLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_REVIEW_REQUEST_EMAIL_TOKENS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getReviewRequestEmailTokens: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetReviewRequestEmailTokensLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetReviewRequestEmailTokensLazyQueryReturn<T>;
}

type UseGetReviewRequestEmailTokensSuspenseQueryReturn<T extends boolean> =
  Omit<
    UseSuspenseQueryResult<
      Record<'result', References.GetReviewRequestEmailTokensResponseType>
    >,
    'data'
  > & {
    data: T extends true
      ? Record<
          'getReviewRequestEmailTokens',
          References.GetReviewRequestEmailTokensResponseType
        >
      : References.GetReviewRequestEmailTokensResponseType;
  };

export function useGetReviewRequestEmailTokensSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetReviewRequestEmailTokensResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetReviewRequestEmailTokensSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_REVIEW_REQUEST_EMAIL_TOKENS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getReviewRequestEmailTokens: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetReviewRequestEmailTokensSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetReviewRequestEmailTokensSuspenseQueryReturn<T>;
}

type UsePreviewReviewRequestEmailQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.PreviewReviewRequestEmailResponseType>,
    References.PreviewReviewRequestEmailRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'previewReviewRequestEmail',
            References.PreviewReviewRequestEmailResponseType
          >
        : References.PreviewReviewRequestEmailResponseType)
    | undefined;
};

export function usePreviewReviewRequestEmailQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.PreviewReviewRequestEmailResponseType>,
    References.PreviewReviewRequestEmailRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UsePreviewReviewRequestEmailQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.PREVIEW_REVIEW_REQUEST_EMAIL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            previewReviewRequestEmail: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UsePreviewReviewRequestEmailQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UsePreviewReviewRequestEmailQueryReturn<T>;
}

type UsePreviewReviewRequestEmailLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.PreviewReviewRequestEmailResponseType>,
    References.PreviewReviewRequestEmailRequestType,
    T extends true
      ? Record<
          'previewReviewRequestEmail',
          References.PreviewReviewRequestEmailResponseType
        >
      : References.PreviewReviewRequestEmailResponseType
  >;

export function usePreviewReviewRequestEmailLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.PreviewReviewRequestEmailResponseType>,
    References.PreviewReviewRequestEmailRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UsePreviewReviewRequestEmailLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.PREVIEW_REVIEW_REQUEST_EMAIL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            previewReviewRequestEmail: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UsePreviewReviewRequestEmailLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UsePreviewReviewRequestEmailLazyQueryReturn<T>;
}

type UsePreviewReviewRequestEmailSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.PreviewReviewRequestEmailResponseType>,
    References.PreviewReviewRequestEmailRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'previewReviewRequestEmail',
        References.PreviewReviewRequestEmailResponseType
      >
    : References.PreviewReviewRequestEmailResponseType;
};

export function usePreviewReviewRequestEmailSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.PreviewReviewRequestEmailResponseType>,
    References.PreviewReviewRequestEmailRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UsePreviewReviewRequestEmailSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.PREVIEW_REVIEW_REQUEST_EMAIL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            previewReviewRequestEmail: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UsePreviewReviewRequestEmailSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UsePreviewReviewRequestEmailSuspenseQueryReturn<T>;
}

type UseGetReviewTagsQueryReturn<T extends boolean> = Omit<
  QueryResult<Record<'result', References.GetReviewTagsResponseType>>,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getReviewTags', References.GetReviewTagsResponseType>
        : References.GetReviewTagsResponseType)
    | undefined;
};

export function useGetReviewTagsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetReviewTagsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetReviewTagsQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_REVIEW_TAGS_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getReviewTags: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetReviewTagsQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetReviewTagsQueryReturn<T>;
}

type UseGetReviewTagsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetReviewTagsResponseType>,
    {},
    T extends true
      ? Record<'getReviewTags', References.GetReviewTagsResponseType>
      : References.GetReviewTagsResponseType
  >;

export function useGetReviewTagsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetReviewTagsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetReviewTagsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_REVIEW_TAGS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getReviewTags: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetReviewTagsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetReviewTagsLazyQueryReturn<T>;
}

type UseGetReviewTagsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetReviewTagsResponseType>
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getReviewTags', References.GetReviewTagsResponseType>
    : References.GetReviewTagsResponseType;
};

export function useGetReviewTagsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetReviewTagsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetReviewTagsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_REVIEW_TAGS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getReviewTags: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetReviewTagsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetReviewTagsSuspenseQueryReturn<T>;
}

type UseGetReviewerDisplayNameQueryReturn<T extends boolean> = Omit<
  QueryResult<Record<'result', References.GetReviewerDisplayNameResponseType>>,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getReviewerDisplayName',
            References.GetReviewerDisplayNameResponseType
          >
        : References.GetReviewerDisplayNameResponseType)
    | undefined;
};

export function useGetReviewerDisplayNameQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetReviewerDisplayNameResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetReviewerDisplayNameQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_REVIEWER_DISPLAY_NAME_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getReviewerDisplayName: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetReviewerDisplayNameQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetReviewerDisplayNameQueryReturn<T>;
}

type UseGetReviewerDisplayNameLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetReviewerDisplayNameResponseType>,
    {},
    T extends true
      ? Record<
          'getReviewerDisplayName',
          References.GetReviewerDisplayNameResponseType
        >
      : References.GetReviewerDisplayNameResponseType
  >;

export function useGetReviewerDisplayNameLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetReviewerDisplayNameResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetReviewerDisplayNameLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_REVIEWER_DISPLAY_NAME_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getReviewerDisplayName: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetReviewerDisplayNameLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetReviewerDisplayNameLazyQueryReturn<T>;
}

type UseGetReviewerDisplayNameSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetReviewerDisplayNameResponseType>
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getReviewerDisplayName',
        References.GetReviewerDisplayNameResponseType
      >
    : References.GetReviewerDisplayNameResponseType;
};

export function useGetReviewerDisplayNameSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetReviewerDisplayNameResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetReviewerDisplayNameSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_REVIEWER_DISPLAY_NAME_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getReviewerDisplayName: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetReviewerDisplayNameSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetReviewerDisplayNameSuspenseQueryReturn<T>;
}

type UseGetOwnReviewsByAppIdsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetOwnReviewsByAppIdsResponseType>,
    References.GetOwnReviewsByAppIdsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getOwnReviewsByAppIds',
            References.GetOwnReviewsByAppIdsResponseType
          >
        : References.GetOwnReviewsByAppIdsResponseType)
    | undefined;
};

export function useGetOwnReviewsByAppIdsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetOwnReviewsByAppIdsResponseType>,
    References.GetOwnReviewsByAppIdsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetOwnReviewsByAppIdsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_OWN_REVIEWS_BY_APP_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getOwnReviewsByAppIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetOwnReviewsByAppIdsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetOwnReviewsByAppIdsQueryReturn<T>;
}

type UseGetOwnReviewsByAppIdsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetOwnReviewsByAppIdsResponseType>,
    References.GetOwnReviewsByAppIdsRequestType,
    T extends true
      ? Record<
          'getOwnReviewsByAppIds',
          References.GetOwnReviewsByAppIdsResponseType
        >
      : References.GetOwnReviewsByAppIdsResponseType
  >;

export function useGetOwnReviewsByAppIdsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetOwnReviewsByAppIdsResponseType>,
    References.GetOwnReviewsByAppIdsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetOwnReviewsByAppIdsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_OWN_REVIEWS_BY_APP_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getOwnReviewsByAppIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetOwnReviewsByAppIdsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetOwnReviewsByAppIdsLazyQueryReturn<T>;
}

type UseGetOwnReviewsByAppIdsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetOwnReviewsByAppIdsResponseType>,
    References.GetOwnReviewsByAppIdsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getOwnReviewsByAppIds',
        References.GetOwnReviewsByAppIdsResponseType
      >
    : References.GetOwnReviewsByAppIdsResponseType;
};

export function useGetOwnReviewsByAppIdsSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetOwnReviewsByAppIdsResponseType>,
    References.GetOwnReviewsByAppIdsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetOwnReviewsByAppIdsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_OWN_REVIEWS_BY_APP_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getOwnReviewsByAppIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetOwnReviewsByAppIdsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetOwnReviewsByAppIdsSuspenseQueryReturn<T>;
}
